<footer [style.backgroundColor]="brandColor">
    <div class="footer-wrapper">
        <div><a href="mailto:hello@noos.global"><img loading="lazy" src="/assets/icons/envelope.svg" alt="mail"></a></div>
        <div><a href="https://www.linkedin.com/company/noos-global/" target="_blank"><img loading="lazy" src="/assets/icons/social-linkedin-white.svg" alt="linkedin"></a></div>
        <div class="text-div">Made with love for our 🌍 NooS global SAS &#9400; {{ year }}</div>
    </div>
</footer>
